import { render, staticRenderFns } from "./LoaderIconSmall.vue?vue&type=template&id=6a1ee3b6&scoped=true&"
import script from "./LoaderIconSmall.vue?vue&type=script&lang=js&"
export * from "./LoaderIconSmall.vue?vue&type=script&lang=js&"
import style0 from "./LoaderIconSmall.vue?vue&type=style&index=0&id=6a1ee3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ee3b6",
  null
  
)

export default component.exports